import {
  validateServiceRequest,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import { z } from 'zod';

// shopTitle 검증용 Zod 스키마
const ShopTitleValidationSchema = z.object({
  shopTitle: z
    .string()
    .min(1, '큐레이터샵 타이틀을 입력해주세요')
    .max(50, '큐레이터샵 타이틀은 50자 이하로 입력해주세요')
    .regex(/^[a-zA-Z0-9]+$/, '큐레이터샵 타이틀은 영문과 숫자만 사용 가능합니다'),
});

// Service Layer 표준에 맞는 검증 함수
export const validateShopTitle = withServiceErrorCapture(
  (shopTitle: string): { isValid: boolean; errorMessage?: string } => {
    try {
      // Zod 스키마를 사용한 검증
      const validationRequest = validateServiceRequest(ShopTitleValidationSchema);
      validationRequest({ shopTitle });

      return { isValid: true };
    } catch (error) {
      // Zod 검증 실패 시 에러 메시지 추출
      if (error instanceof Error) {
        return {
          isValid: false,
          errorMessage: error.message,
        };
      }

      return {
        isValid: false,
        errorMessage: '검증 중 오류가 발생했습니다',
      };
    }
  },
);
